import { map } from 'ramda'

export default class ChangePasswordController {
  constructor($timeout, $sessionStorage, IdentityService, AuthService) {
    'ngInject'

    this.$timeout = $timeout
    this.$sessionStorage = $sessionStorage
    this.IS = IdentityService
    this.AS = AuthService
    this.containsDigit = /\d/ // test if string contains at least 1 digit
    this.state = {
      updating: false,
      updated: false,
      updateError: false,
      errorObj: {},
    }
  }

  updatePassword(password) {
    this.dismiss()
    this.IS.User.setPassword
      .post(password)
      .then(updatedUser => {
        this.$sessionStorage.user = updatedUser
        this.state.updating = true
        this.$timeout(() => {
          this.state.updating = false
          this.state.updated = true
        }, 1000)
      })
      .catch(err => {
        this.state.errorObj = this.processErrorObj(err.data)
        this.state.updateError = true
        console.error('COULD NOT SET PASSWORD: ', this.state.errorObj)
      })
  }

  processErrorObj(errorData) {
    return map(err => err.join(''), errorData)
  }

  dismiss() {
    this.state.updateError = false
    this.state.updated = false
    this.state.errorObj = {}
  }
}
